import { useContext } from 'react';
import { useAppTranslation } from 'services/i18n';
import { PreviewContext } from './PreviewContext';

import { ReactComponent as CertificateIcon } from 'icons/certificate.svg';

// Mobile-only bar with preview actions, rendered between the content and the keyboard controls
export const PreviewActions = () => {
  const preview = useContext(PreviewContext);
  const t = useAppTranslation();

  if (!preview) return null;

  return (
    <div className="tw-flex tw-h-72 tw-w-full tw-items-center tw-gap-12 tw-bg-[#1a1a1a] tw-px-16 tw-py-12 sm:tw-hidden">
      <button
        className="tw-h-46 tw-flex-1 tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-white/40 tw-bg-transparent tw-text-[15px] tw-font-medium tw-text-white"
        onClick={preview.leavePreview}
      >
        {t('contentViewer.previewBar.leave')}
      </button>
      <button
        className="tw-flex tw-h-46 tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-8 tw-rounded-lg tw-border-none tw-bg-lightGreen tw-text-[15px] tw-font-medium tw-text-white"
        onClick={preview.showCertificatePreview}
      >
        <CertificateIcon className="tw-shrink-0" />
        {t('contentViewer.previewBar.certificate')}
      </button>
    </div>
  );
};
